import dayjs from 'dayjs';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import loadDayjsLocale from './loadDayjsLocale';

const DEFAULT_LOCALE = 'en-US';

function interpolateDates(valueToInterpolate, dateFormat) {
  if (valueToInterpolate instanceof Date && dateFormat) {
    return dayjs(valueToInterpolate).format(dateFormat);
  }
  return valueToInterpolate;
}

async function readBackendLanguagePack(language, namespace, callback) {
  try {
    const languagePack = await import(`../../locales/${language}.json`);
    // import dayjs file after main locale
    // so date locale only updates if the main language load succeeded;
    loadDayjsLocale(language);
    return callback(null, languagePack);
  } catch (error) {
    return callback(error, false);
  }
}

export async function initLanguages(language) {
  return i18next
    .use(initReactI18next)
    .use({
      type: 'backend',
      read: readBackendLanguagePack,
    })
    .init({
      lng: language || DEFAULT_LOCALE,
      fallbackLng: DEFAULT_LOCALE,
      debug: false,
      interpolation: {
        format: interpolateDates,
        // not needed for react as it escapes by default
        escapeValue: false,
      },
    });
}

/**
 * Used for Auth Screens which do not have access to the backend Sapling language config
 */
export function getBrowserLocale() {
  const locale = navigator.language;
  return locale || DEFAULT_LOCALE;
}

export { default } from 'i18next';
